import toastr from "toastr";

export interface ActivityDateData {
  id: number;
  start_date?: string;
  end_date?: string;
  is_not_pair?: boolean;
  start_time?: string;
  end_time?: string;
  _destroy?: number;
}

export type ValidationTimeErrorType = "time_missing" | "time_order" | null;

export class ActivityDate {
  static getErrorMessage(errorType: ValidationTimeErrorType): string | null {
    switch (errorType) {
      case "time_missing":
        return "開始時刻と終了時刻は両方入力してください";
      case "time_order":
        return "開始時刻は終了時刻より前にしてください";
      default:
        return null;
    }
  }

  /**
   * 時間のバリデーションを実行し、エラーがあればその種類を返す
   * @returns null: 有効, "time_missing": 開始・終了時間の片方のみ入力, "time_order": 開始時間が終了時間より後
   */
  static validateTime(data: ActivityDateData): ValidationTimeErrorType {
    if (data._destroy === 1) return null;
    if (!data.is_not_pair) return null;

    const hasStartTime = !!(data.start_time && data.start_time !== "");
    const hasEndTime = !!(data.end_time && data.end_time !== "");

    // NOTE: 片方のみ入力されている場合はエラー
    if ((hasStartTime && !hasEndTime) || (!hasStartTime && hasEndTime)) {
      return "time_missing";
    }

    // NOTE: 両方入力されている場合の順序チェック
    if (hasStartTime && hasEndTime) {
      // NOTE: 時刻文字列を比較（HH:MM形式なら文字列比較でOK）
      if (data.start_time! >= data.end_time!) {
        return "time_order";
      }
    }

    return null;
  }

  /**
   * 複数の活動日データの時間バリデーションを実行し、エラーがあればtoastrで通知
   * @param attributes 活動日データの配列
   * @returns true: 有効, false: エラーあり
   */
  static validateAndNotifyTimeErrors(
    attributes: ActivityDateData[]
  ): boolean {
    if (!Array.isArray(attributes)) return true;

    let hasTimeMissing = false;
    let hasTimeOrder = false;

    attributes.forEach((attr) => {
      const error = ActivityDate.validateTime(attr);
      if (error === "time_missing") hasTimeMissing = true;
      if (error === "time_order") hasTimeOrder = true;
    });

    if (hasTimeMissing) {
      const message = ActivityDate.getErrorMessage("time_missing");
      if (message) toastr.warning(message);
    }
    if (hasTimeOrder) {
      const message = ActivityDate.getErrorMessage("time_order");
      if (message) toastr.warning(message);
    }

    return !hasTimeMissing && !hasTimeOrder;
  }
}
